module.exports = __webpack_public_path__ + "media/images/icon__arrow-left--rb-light-gray-01d66602e74bbe703b3ad789b5b274b6.png";